import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "电影", to: "/category/movie" },
  { label: "电视剧", to: "/category/tv" },
  { label: "综艺", to: "/category/variety" },
  { label: "动漫", to: "/category/anime" },
  { label: "纪录片", to: "/category/documentary" },
];

export default function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [keyword, setKeyword] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname, location.search]);

  const handleSearch = (event: React.FormEvent) => {
    event.preventDefault();
    const value = keyword.trim();
    if (!value) return;
    navigate(`/search?q=${encodeURIComponent(value)}`);
    setKeyword("");
  };

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200 bg-background-50/95 backdrop-blur">
      <div className="mx-auto flex h-16 max-w-[1280px] items-center gap-4 px-4 md:px-6">
        <Link to="/" className="flex shrink-0 items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-lg text-background-50">
            <i className="ri-movie-2-line" />
          </span>
          <span className="text-lg font-bold tracking-tight text-foreground-950 font-heading">
            桔子<span className="text-primary-600">视频</span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 lg:flex">
          {navItems.map((item) => {
            const active =
              item.to === "/"
                ? location.pathname === "/"
                : location.pathname.startsWith(item.to);
            return (
              <Link
                key={item.to}
                to={item.to}
                className={`whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium transition-colors ${
                  active
                    ? "bg-primary-100 text-primary-700"
                    : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                }`}
              >
                {item.label}
              </Link>
            );
          })}
        </nav>

        <div className="ml-auto flex items-center gap-2">
          <form
            onSubmit={handleSearch}
            className="hidden items-center rounded-full border border-background-200 bg-background-100 px-3 py-1.5 md:flex"
          >
            <span className="flex h-5 w-5 items-center justify-center text-foreground-400">
              <i className="ri-search-line text-base" />
            </span>
            <input
              value={keyword}
              onChange={(event) => setKeyword(event.target.value)}
              type="text"
              placeholder="搜索影片、演员"
              aria-label="搜索影片"
              className="w-32 bg-transparent px-2 text-sm text-foreground-950 outline-none placeholder:text-foreground-400 lg:w-44"
            />
          </form>

          <Link
            to="/share-intro"
            className="hidden shrink-0 items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-3.5 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:flex"
          >
            <i className="ri-upload-cloud-2-line text-base" />
            视频分享
          </Link>

          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setMenuOpen((prev) => !prev)}
            className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-200 text-foreground-800 lg:hidden"
          >
            <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 lg:hidden">
          <div className="mx-auto max-w-[1280px] px-4 py-4">
            <form
              onSubmit={handleSearch}
              className="mb-3 flex items-center rounded-full border border-background-200 bg-background-100 px-3 py-2"
            >
              <span className="flex h-5 w-5 items-center justify-center text-foreground-400">
                <i className="ri-search-line text-base" />
              </span>
              <input
                value={keyword}
                onChange={(event) => setKeyword(event.target.value)}
                type="text"
                placeholder="搜索影片、演员"
                aria-label="搜索影片"
                className="w-full bg-transparent px-2 text-sm text-foreground-950 outline-none placeholder:text-foreground-400"
              />
            </form>
            <div className="grid grid-cols-2 gap-2">
              {navItems.map((item) => (
                <Link
                  key={item.to}
                  to={item.to}
                  className="flex items-center gap-2 rounded-md bg-background-100 px-3 py-2.5 text-sm font-medium text-foreground-800"
                >
                  {item.label}
                </Link>
              ))}
            </div>
            <Link
              to="/share-intro"
              className="mt-3 flex items-center justify-center gap-1.5 rounded-md bg-primary-500 px-3.5 py-2.5 text-sm font-medium text-background-50"
            >
              <i className="ri-upload-cloud-2-line text-base" />
              视频分享
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}